import { useState, useEffect } from "react";


interface FirebaseTokenResult {
    fcmToken: string | null;
    deviceType: "ios" | "android" | null;
    isTokenReady: boolean; // 토큰 준비 완료 여부
}

const getDeviceType = (): "ios" | "android" => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ? "ios" : "android";
};


const useFirebaseToken = (): FirebaseTokenResult => {
    const [fcmToken, setToken] = useState<string | null>(null);
    const [deviceType, setDeviceType] = useState<"ios" | "android" | null>(null);
    const [isTokenReady, setIsTokenReady] = useState<boolean>(false);

    useEffect(() => {

        const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);


        window.receiveFCMToken = (receivedToken: string) => {
            if (!receivedToken) return;
            setToken(receivedToken);
            setDeviceType(getDeviceType());
            setIsTokenReady(true); // 토큰 수신 완료
        };


        const tryRequestToken = (retryCount = 0) => {
            if (isIos) {
                // iOS: webkit messageHandlers 주입 대기
                if (window.webkit?.messageHandlers?.nativeApp) {
                    window.webkit.messageHandlers.nativeApp.postMessage({ type: "getFCMToken" });
                } else if (retryCount < 10) {
                    setTimeout(() => tryRequestToken(retryCount + 1), 300);
                } else {
                    console.warn("window.webkit.messageHandlers.getFCMToken을 찾을 수 없습니다.");
                    setIsTokenReady(true);
                }
            } else {
                if (window.android?.requestFCMToken) {
                    window.android.requestFCMToken();
                } else if (retryCount < 10) {
                    setTimeout(() => tryRequestToken(retryCount + 1), 300);
                } else {
                    console.warn("window.android를 찾을 수 없습니다.");
                    setIsTokenReady(true); // 실패해도 블로킹 방지
                }
            }
        };

        if (isIos || window.android !== undefined) {
            // WebView 환경일 때만 토큰 요청
            tryRequestToken();
        } else {
            // 일반 브라우저면 바로 완료 처리
            setIsTokenReady(true);
        }

        return () => {
            delete window.receiveFCMToken;
        };
    }, []);


    return { fcmToken, deviceType, isTokenReady };
};

export default useFirebaseToken;